module.exports = __webpack_public_path__ + "front/img/AMD-logo.1dbd221e.png";